import React from 'react';
import { DiaryEntry } from './DiaryEntry';
export function DiarySection() {
  return <section className="w-full py-12 px-4" data-id="element-45">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-46">
        <DiaryEntry index={0} rotation={-1} title="Das Problem" date="Vor 4 Monaten" content={<>
              <p data-id="element-48">
                Es fing schleichend an.{' '}
                <strong data-id="element-49">Finn hatte immer seltener Stuhlgang</strong> — erst
                jeden zweiten Tag, dann nur noch alle drei Tage. Sein{' '}
                <strong data-id="element-50">Bauch war aufgebläht und hart</strong>. Morgens stand er
                vor seinem Napf und drehte sich einfach weg.
              </p>
              <p data-id="element-51">
                Beim Spaziergang <strong data-id="element-52">war er langsam, lustlos</strong>. Kein
                Rennen, kein Spielen mit anderen Hunden. Er lag den ganzen Tag
                auf seiner Decke und schlief. Ich wusste nicht mehr weiter — das
                war nicht mehr mein Finn.
              </p>
              <p data-id="element-53">
                Beim Tierarzt dann die Diagnose: "
                <strong data-id="element-54">verlangsamte Darmpassage</strong>". Der Darm bewegt sich
                zu langsam, der Stuhl wird hart, der Körper nimmt Giftstoffe
                auf, die längst ausgeschieden sein sollten. Das erklärt alles —
                die Müdigkeit, die Appetitlosigkeit, die Trägheit.
              </p>
              <p data-id="element-55">
                Der Tierarzt empfiehlt mehr Ballaststoffe. Aber welche? Wie
                viel? Und warum hat das normale Futter nicht gereicht?
              </p>
            </>} data-id="element-47" />

        <DiaryEntry index={1} rotation={1} title="Der Wendepunkt" date="Vor 3 Monaten" content={<>
              <p data-id="element-57">
                Ich lese: <strong data-id="element-58">der Darm braucht Ballaststoffe</strong> als
                "Besen". Ohne sie bewegt sich der Darminhalt zu langsam.
              </p>
              <p data-id="element-59">
                Gärung, Fäulnis, Giftstoffe werden zu lange aufgenommen. Das
                erklärt Finns Lethargie. Ich hatte schon so viele Sachen
                ausprobiert — aber dann sah ich, dass fast 900 andere
                Hundehalter das Topping bewertet hatten, viele mit genau
                denselben Problemen wie Finn.
              </p>
            </>} data-id="element-56" />

        <DiaryEntry index={2} rotation={-0.5} title="Die Veränderung" date="Vor 8 Wochen" content={<>
              <p data-id="element-61">
                Ein Futtertopping mit löslichen und unlöslichen Ballaststoffen.
                Johannisbrotmehl, Leinsamen, Topinambur. Ich schleiche es ein.
              </p>
              <p data-id="element-62">
                <strong data-id="element-63">
                  Nach 10 Tagen hatte Finn zum ersten Mal wieder normalen Stuhl.
                </strong>{' '}
                Nach zwei Wochen: der Stuhl ist weicher, gesünder. Er frisst
                morgens wieder mit Appetit.
              </p>
            </>} data-id="element-60" />

        <DiaryEntry index={3} rotation={0.5} title="Heute" date="Heute" content={<>
              <p data-id="element-65">
                <strong data-id="element-66">
                  Finn ist ein anderer Hund. Lebhaft. Hungrig. Aktiv.
                </strong>{' '}
                Sein Darm arbeitet regelmäßig und ruhig.
              </p>
              <p data-id="element-67">
                Ich hätte nie gedacht dass Ballaststoffe so einen Unterschied
                machen können. 🐾
              </p>
            </>} data-id="element-64" />
      </div>
    </section>;
}